import { Button } from "Components/_Shared/Buttons/Button";
import { DialogModal } from "Components/_Shared/DialogModal";
import { Resources, useResource } from "Infrastructure/Translations/Resources";
import type { QuestionnairePdfType } from "./useQuestionnairePdf";

type Props = {
  type: QuestionnairePdfType | null;
  clientEmail: string | null | undefined;
  onClose: () => void;
  onConfirm: (type: QuestionnairePdfType) => void;
};

export const QuestionnairePdfEmailConfirmModal = ({ type, clientEmail, onClose, onConfirm }: Props) => {
  const { t } = useResource();

  const confirmText: Record<QuestionnairePdfType, string> = {
    empty: t(Resources.Questionnaire.Evaluation.SendPdf.Confirm.EmptyText, { email: clientEmail }),
    filled: t(Resources.Questionnaire.Evaluation.SendPdf.Confirm.EvaluatedText, { email: clientEmail }),
  };

  return (
    <DialogModal
      isOpen={type !== null}
      onClose={onClose}
      title={t(Resources.Questionnaire.Evaluation.SendPdf.Confirm.Title)}
      subtitle={type ? confirmText[type] : ""}
      primaryAction={
        <Button
          onClick={() => {
            if (type) onConfirm(type);
            onClose();
          }}
        >
          {t(Resources.Common.Yes)}
        </Button>
      }
      secondaryAction={
        <Button color="secondary" onClick={onClose}>
          {t(Resources.Common.No)}
        </Button>
      }
    />
  );
};
